/**
 * LE CRIPTOVALUTE DEL TICKER nel piede Nova (TickerCripto.js): le monete
 * che NOWPayments accetta e che un giocatore riconosce, ognuna con sigla,
 * nome, colore del marchio e icona in /assets/cripto/<sigla>.svg.
 *
 * NOWPayments ne elenca piu' di trecento, quasi tutte senza un'icona che
 * dica qualcosa a chi guarda: questo elenco e' curato, nell'ordine in cui
 * scorrono, e si allunga aggiungendo una riga e un file. E' una striscia
 * DECORATIVA, di fiducia: non dice quali monete sono accese sulla skin (quelle
 * le decide la Cassa, da GET /private/pagamenti/stato) e non si tocca.
 *
 * Le icone sono i loghi ufficiali delle monete, presi da raccolte con
 * licenza libera (cryptocurrency-icons, CC0; web3icons, MIT; per BUSD e
 * NOW Token le immagini di Trust Wallet assets): una moneta nuova porta il
 * suo file con lo stesso nome della sigla.
 */
export const CRIPTO = [
  {sigla: 'BTC', nome: 'Bitcoin', colore: '#F7931A'},
  {sigla: 'ETH', nome: 'Ethereum', colore: '#627EEA'},
  {sigla: 'USDT', nome: 'Tether', colore: '#26A17B'},
  {sigla: 'USDC', nome: 'USD Coin', colore: '#2775CA'},
  {sigla: 'BNB', nome: 'BNB', colore: '#F3BA2F'},
  {sigla: 'SOL', nome: 'Solana', colore: '#9945FF'},
  {sigla: 'XRP', nome: 'XRP', colore: '#346AA9'},
  {sigla: 'LTC', nome: 'Litecoin', colore: '#345D9D'},
  {sigla: 'DOGE', nome: 'Dogecoin', colore: '#C2A633'},
  {sigla: 'TRX', nome: 'TRON', colore: '#EF0027'},
  {sigla: 'ADA', nome: 'Cardano', colore: '#0033AD'},
  {sigla: 'TON', nome: 'Toncoin', colore: '#0098EA'},
  {sigla: 'AVAX', nome: 'Avalanche', colore: '#E84142'},
  {sigla: 'DOT', nome: 'Polkadot', colore: '#E6007A'},
  {sigla: 'POL', nome: 'Polygon', colore: '#8247E5'},
  {sigla: 'LINK', nome: 'Chainlink', colore: '#2A5ADA'},
  {sigla: 'SHIB', nome: 'Shiba Inu', colore: '#FFA409'},
  {sigla: 'DAI', nome: 'Dai', colore: '#F5AC37'},
  {sigla: 'BCH', nome: 'Bitcoin Cash', colore: '#8DC351'},
  {sigla: 'XMR', nome: 'Monero', colore: '#FF6600'},
  {sigla: 'XLM', nome: 'Stellar', colore: '#14B6E7'},
  {sigla: 'ATOM', nome: 'Cosmos', colore: '#5064FB'},
  {sigla: 'NEAR', nome: 'NEAR', colore: '#00C08B'},
  {sigla: 'ETC', nome: 'Ethereum Classic', colore: '#328332'},
  {sigla: 'UNI', nome: 'Uniswap', colore: '#FF007A'},
  {sigla: 'PEPE', nome: 'Pepe', colore: '#3D8F3D'},
  {sigla: 'APT', nome: 'Aptos', colore: '#00A3A3'},
  {sigla: 'ARB', nome: 'Arbitrum', colore: '#28A0F0'},
  {sigla: 'OP', nome: 'Optimism', colore: '#FF0420'},
  {sigla: 'FIL', nome: 'Filecoin', colore: '#0090FF'},
  {sigla: 'ALGO', nome: 'Algorand', colore: '#3D3D3D'},
  {sigla: 'VET', nome: 'VeChain', colore: '#15BDFF'},
  {sigla: 'XTZ', nome: 'Tezos', colore: '#2C7DF7'},
  {sigla: 'EOS', nome: 'EOS', colore: '#443F54'},
  {sigla: 'AAVE', nome: 'Aave', colore: '#B6509E'},
  {sigla: 'SAND', nome: 'The Sandbox', colore: '#00ADEF'},
  {sigla: 'MANA', nome: 'Decentraland', colore: '#FF2D55'},
  {sigla: 'AXS', nome: 'Axie Infinity', colore: '#0055D5'},
  {sigla: 'CRO', nome: 'Cronos', colore: '#103F68'},
  {sigla: 'FTM', nome: 'Fantom', colore: '#1969FF'},
  {sigla: 'ZEC', nome: 'Zcash', colore: '#ECB244'},
  {sigla: 'DASH', nome: 'Dash', colore: '#008CE7'},
  {sigla: 'KAS', nome: 'Kaspa', colore: '#70C7BA'},
  {sigla: 'SUI', nome: 'Sui', colore: '#4DA2FF'},
  {sigla: 'INJ', nome: 'Injective', colore: '#00B6D6'},
  {sigla: 'HBAR', nome: 'Hedera', colore: '#3D3D3D'},
  {sigla: 'ICP', nome: 'Internet Computer', colore: '#29ABE2'},
  {sigla: 'BUSD', nome: 'Binance USD', colore: '#F0B90B'},
  {sigla: 'TUSD', nome: 'TrueUSD', colore: '#1A5AFE'},
  {sigla: 'NOW', nome: 'NOW Token', colore: '#6B5BFF'},
];

/** L'icona di una moneta. */
export function iconaCripto(sigla) {
  return '/assets/cripto/' + String(sigla || '').toLowerCase() + '.svg';
}

/**
 * Le monete che scorrono, scelte dal modulo Piè di pagina (Monete del
 * ticker) per sigla e nell'ordine scritto: le sigle che questo elenco non
 * conosce si saltano, e se non ne resta nessuna scorrono tutte.
 */
export function moneteDelTicker(sigle) {
  const scelte = (sigle || []).map((s) => CRIPTO.find((m) => m.sigla === s)).filter(Boolean);
  return scelte.length ? scelte : CRIPTO;
}
